module.exports = __webpack_public_path__ + "static/media/developers_overview_2.baa01980.png";